import { Component, OnInit} from '@angular/core';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { PracticeService } from '../../core/services/v2/practice.service';
import { UserService } from '../../core/services/v2/user.service';

@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.scss']
})
export class AdminLayoutComponent implements OnInit {
  role: string;
  showSidebar: boolean = true;
  profilelist = true;
  photoUrlsend: string;
  sideNavOpened = true;
  hasAccess: boolean = false;
  sidebar = {
    referralsCollapsed: false,
    settingsCollapsed: false,
  };
  isAdmin: boolean = false;
  isAHIAdmin: boolean = false;
  expandNav = false;
  showPhysicianSelector = true;

  constructor(private _practiceService: PracticeService,
    private _userService: UserService,
    private _router: Router) {
    this.showPhysicianSelector = true;
  }
  
  ngOnInit(): void {

    this.LoadStatus();
  }

  private LoadStatus() {
    this._userService.getUserDetails().subscribe(
      (user) => {
        //console.log(user);
        this._practiceService.setCurrentUser(user);
        this.isAHIAdmin = this._practiceService.checkForAHI();
        this.isAdmin = this._practiceService.checkForAdmin();

      },
      (error) => { console.error(error); }
    );
  }
  openProfileList() {
    this.profilelist = false;
  }
  
  expandSidebar(event) {
    if (event.type === 'mouseover') {
      this.expandNav = true;
    } else {
      this.expandNav = false;
    }
  }
}
